

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBynMoFpXLNaj43wh2fPDsX-Agb8KnDwyY",
    authDomain: "chat-app2-7a67e.firebaseapp.com",
    projectId: "chat-app2-7a67e",
    storageBucket: "chat-app2-7a67e.appspot.com",
    messagingSenderId: "516331415404",
    appId: "1:516331415404:web:0b73a7dfa848fc5deef549",
};

export default firebaseConfig